import { showSnackbar } from "utils/snack_bar/store/action";
import { executeMutation, executeQuery } from "utils/services/apiServices";
import { FETCH_ALL_FEATURED_ADS } from "../graphql/query";
import {
  CREATE_FEATURED_ADS,
  DELETE_FEATURED_ADS,
  UPDATE_FEATURED_ADS,
  UPLOAD_FEATURED_ADS_VIDEO,
} from "../graphql/mutation";
import { FeaturedAdsEnum } from "props/enum";
import { ClientPayloadProps } from "modules/video/video_detail/store/actionType";
import { actionTypes, FeaturedAdsInput, FeaturedAdsProps, UploadFeaturedAdsVideoInput } from "./actionType";

export const featchFeaturedAdsRequest = () => ({
  type: actionTypes.FETCH_FEATURED_ADS_REQUEST,
});

export const featchFeaturedAdsSuccess = (payload: FeaturedAdsProps[]) => ({
  type: actionTypes.FETCH_FEATURED_ADS_SUCCESS,
  payload,
});

export const featchFeaturedAdsFail = (payload: string) => ({
  type: actionTypes.FETCH_FEATURED_ADS_FAIL,
  payload,
});

export const featchFeaturedAds = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(featchFeaturedAdsRequest());
      const response = await executeQuery(FETCH_ALL_FEATURED_ADS);
      const jsonData = response.data?.fetchAllFeaturedAd;
      if (jsonData?.error === null) {
        dispatch(featchFeaturedAdsSuccess(jsonData?.data.featuredAds));
      } else {
        dispatch(featchFeaturedAdsFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(featchFeaturedAdsFail("Failed to fetch"));
    }
  };
};

export const createFeaturedAdsRequest = () => ({
  type: actionTypes.CREATE_FEATURED_ADS_REQUEST,
});

export const createFeaturedAdsSuccess = (payload: FeaturedAdsProps) => ({
  type: actionTypes.CREATE_FEATURED_ADS_SUCCESS,
  payload,
});
export const createFeaturedAdsFail = (payload: string) => ({
  type: actionTypes.CREATE_FEATURED_ADS_FAIL,
  payload,
});
export const createFeaturedAds = (input: FeaturedAdsInput) => {
  return async (dispatch: any) => {
    try {
      const inputData = {
        input: input,
      };
      await dispatch(createFeaturedAdsRequest());
      const response = await executeMutation(CREATE_FEATURED_ADS, inputData);
      const jsonData = response.data?.createFeaturedAd;
      if (jsonData?.error === null) {
        if(input.featured_type === FeaturedAdsEnum.video){
          localStorage.setItem("featuredAds", JSON.stringify(jsonData.data))
        }
        dispatch(createFeaturedAdsSuccess(jsonData?.data.featuredAd));
        dispatch(showSnackbar("Success! featured ads created."));
      } else {
        dispatch(createFeaturedAdsFail(jsonData?.error.message));
        dispatch(showSnackbar(`${jsonData.error ? jsonData.error : "Fail to create."}`));
      }
    } catch (error: any) {
      dispatch(createFeaturedAdsFail("Something went wrong, Try again later"));
    }
  };
};
export const updateFeaturedAdsRequest = () => ({
  type: actionTypes.UPDATE_FEATURED_ADS_REQUEST,
});

export const updateFeaturedAdsSuccess = (payload: FeaturedAdsProps) => ({
  type: actionTypes.UPDATE_FEATURED_ADS_SUCCESS,
  payload,
});
export const updateFeaturedAdsFail = (payload: string) => ({
  type: actionTypes.UPDATE_FEATURED_ADS_FAIL,
  payload,
});
export const updateFeaturedAds = (input: FeaturedAdsInput, ad_id: string) => {
  return async (dispatch: any) => {
    try {
      const inputData = {
        input: input,
        ad_id: ad_id,
      };
      await dispatch(updateFeaturedAdsRequest());
      const response = await executeMutation(UPDATE_FEATURED_ADS, inputData);
      const jsonData = response.data?.updateFeaturedAd;
      if (jsonData?.error === null) {
        dispatch(updateFeaturedAdsSuccess(jsonData?.data.featuredAd));
        dispatch(showSnackbar("Success! featured ads updated."));
      } else {
        dispatch(updateFeaturedAdsFail(jsonData?.error.message));
        dispatch(showSnackbar(`${jsonData.error ? jsonData.error : "Fail to update."}`));
      }
    } catch (error: any) {
      dispatch(updateFeaturedAdsFail("Something went wrong, Try again later"));
    }
  };
};
export const uploadFeaturedAdsVideoRequest = () => ({
  type: actionTypes.UPLOAD_FEATURED_ADS_VIDEO_REQUEST,
});

export const uploadFeaturedAdsVideoSuccess = (payload: ClientPayloadProps) => ({
  type: actionTypes.UPLOAD_FEATURED_ADS_VIDEO_SUCCESS,
  payload,
});
export const uploadFeaturedAdsVideoFail = (payload: string) => ({
  type: actionTypes.UPLOAD_FEATURED_ADS_VIDEO_FAIL,
  payload,
});
export const uploadFeaturedAdsVideo = (input: UploadFeaturedAdsVideoInput) => {
  return async (dispatch: any) => {
    try {
      await dispatch(uploadFeaturedAdsVideoRequest());
      const response = await executeMutation(UPLOAD_FEATURED_ADS_VIDEO, input);
      const jsonData = response.data?.uploadFeaturedVideo
      if (jsonData?.error === null) {
        dispatch(uploadFeaturedAdsVideoSuccess(jsonData?.data.client_playload));
        dispatch(showSnackbar("Success! featured ads video uploaded."));
      } else {
        dispatch(uploadFeaturedAdsVideoFail(jsonData?.error.message));
        dispatch(showSnackbar(`${jsonData.error ? jsonData.error : "Fail to upload."}`));
      }
    } catch (error: any) {
      dispatch(uploadFeaturedAdsVideoFail("Something went wrong, Try again later"));
    }
  };
};

export const deleteFeaturedAdsRequest = () => ({
  type: actionTypes.DELETE_FEATURED_ADS_REQUEST,
});

export const deleteFeaturedAdsSuccess = (payload: string) => ({
  type: actionTypes.DELETE_FEATURED_ADS_SUCCESS,
  payload,
});
export const deleteFeaturedAdsFail = (payload: string) => ({
  type: actionTypes.DELETE_FEATURED_ADS_FAIL,
  payload,
});
export const deleteFeaturedAds = (ad_id: string) => {
  return async (dispatch: any) => {
    try {
      await dispatch(deleteFeaturedAdsRequest());
      const response = await executeMutation(DELETE_FEATURED_ADS, {ad_id:ad_id});
      const jsonData = response.data?.deleteFeaturedAd;
      if (jsonData?.error === null) {
        dispatch(deleteFeaturedAdsSuccess(ad_id));
        dispatch(showSnackbar("Success! featured ads deleted."));
      } else {
        dispatch(deleteFeaturedAdsFail(jsonData?.error.message));
        dispatch(showSnackbar(`${jsonData.error ? jsonData.error : "Fail to delete."}`));
      }
    } catch (error: any) {
      dispatch(deleteFeaturedAdsFail("Something went wrong, Try again later"));
    }
  };
};

//RESET
export const ResetFeaturedAds = () => ({
  type: actionTypes.RESET_FEATURED_ADS,
});

export const resetFeaturedAds = () => {
  return async (dispatch: any) => {
    dispatch(ResetFeaturedAds());
  };
};
